<template>
  <v-card>
    <v-card-title class="title">
      {{ $t(title) }}
    </v-card-title>

    <v-card-text>
      <v-layout
        row
        wrap>
        <v-flex
          :class="currentTerm ? 'md9' : ''"
          xs12
        >
          <v-textarea
            :label="$t('Contents')"
            v-model="contents"
            outline
          />
        </v-flex>
        <v-flex
          v-if="currentTerm"
          xs12
          md3
        >
          <v-layout
            row
            wrap
            class="subheading">
            <v-flex
              xs12
              pb-0>
              <span class="font-weight-bold">{{ $t('Created At') }}:</span> {{ currentTerm.created_at | timezone }}
            </v-flex>
            <v-flex
              xs12
              pb-0>
              <span class="font-weight-bold">{{ $t('Updated At') }}:</span> {{ currentTerm.updated_at | timezone }}
            </v-flex>
            <v-flex xs12>
              <span class="font-weight-bold">{{ $t('Version') }}: </span>
              <span class="title">{{ currentTerm.version }}</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="pa-3">
      <v-btn
        color="primary"
        @click="create"
      >
        {{ $t('Save New Version') }}
      </v-btn>
      <v-spacer/>
      <v-btn
        :disabled="!currentTerm"
        color="primary"
        @click="update"
      >
        {{ $t('Update') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'TermsCard',

  props: {
    type: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      allTerms: [],
      currentTerm: null,
      contents: ''
    }
  },

  computed: {
    title () {
      const capitalize = str => `${str.charAt(0).toUpperCase()}${str.slice(1)}`

      return capitalize(this.type) + ' Terms of Service'
    }
  },

  async mounted () {
    await this.init()
  },

  methods: {
    async create () {
      const tos = this.$http.make('auth:tos', {
        type: this.type,
        contents: this.contents
      })

      try {
        await tos.save()
        await this.init()
        this.$toast.sucess(this.$t('New ToS version saved.'))
      } catch (e) {
        this.$toast.error(this.$t('Something went wrong while creating new ToS. Please try again.'))
      }
    },

    async init () {
      this.terms = await this.$http.make('auth:tos').where('type', 'eq', this.type).get()
      if (this.terms.length > 0) {
        this.currentTerm = this.terms[this.terms.length - 1]
        this.contents = this.currentTerm.contents
      }
    }
  }
}
</script>
